
$(function() {
    // カレンダー
    var selected_day = null;

    // 講座開催日選択時
    $('.calendar-btn').on('click', function() {
        initModal($(this));
    });

    function initModal(thisElm) {
        thisElm.modaal({
            content_source: '#calendar-modal',
            hide_close: true,
            start_open: true,
            after_open: () => initCalendar(),
            after_close: () => {
                selected_day = null;
            },
        });

        $('#modal-close').on('click', function() {
            $('#lesson_date').val(null);
            $(`.calendar-btn`).modaal('close');
        });

        $('#select-date').on('click', function() {
            if (selected_day) {
                $('#lesson_date').val(moment(selected_day).format('YYYY/MM/DD'));
            }

            $(`.calendar-btn`).modaal('close');
        });
    }

    function initCalendar() {
        let initDate = new Date($('#lesson_date').val());
        initDate = isNaN(initDate) ? null : initDate;

        let el = $('.contact__calendar')[0];
        var calendar = new FullCalendar.Calendar(el, {
            contentHeight: 'auto',
            windowResizeDelay: 500,
            locale: 'ja',
            initialView: 'dayGridMonth',
            headerToolbar: {
                center: 'title',
                left: 'prev',
                right: 'next',
            },
            initialDate: initDate,
            dateClick: function(info) {
                const date = info.dateStr;
                selected_day = date;
                info.view.calendar.select(date);
            },
            views: {
                dayGridMonth: {
                    dayCellContent: function(e) {
                        e.dayNumberText = e.dayNumberText.replace('日', '');
                    }
                }
            },
            titleFormat: function(date) {
                month = date.date.month;
                if ( month > 8 ) {
                    largeMonth = `${date.date.year}. ${date.date.month + 1}`;
                    return largeMonth;
                } else {
                    smallMonth = `${date.date.year}. 0${date.date.month + 1}`;
                    return smallMonth;
                }
            }
        });

        calendar.render();

        if (initDate) {
            calendar.select(initDate);
        }

        $(window).on('resize', function() {
            if (calendar && $('calendar-modal').css('display') != 'none') {
                calendar.render();
            }
        });
    }
});
